export default __webpack_public_path__ + "static/media/bol_scan_4.c471db8e.svg";